<template>
  <div class="question question-topic effect-transition-fast">
    <div class="question-topic__head display-flex full-width" @click="handleToggleQuestionDesc(question.questionId)">
      <div class="question-topic__head__title display-flex-center">
        <i class="icon-arrow-down secondary-color-txt font-size-15 position-rel effect-transition-fast" :class="{'active': idOpenQuestion === question.questionId}"></i>
        <b class="primary-color display-block text-center font-size-16" v-if="question.title">{{ question.title }}</b> 
      </div>
      <div class="question__head__content primary-color-txt" v-html="question.content"></div>
    </div>
    <transition name="list">
      <div class="question-topic__img text-center margin-center" v-if="idOpenQuestion === question.questionId && question.imageUrl" :style="`max-width: ${question.imageWidth}px; max-height: ${question.imageHeight}px`">
        <img 
          :src="`${urlQuestionImg}/${question.imageUrl}`"
          alt="Ảnh câu hỏi"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import { getQuestionDetail } from './../_api/'
import { APP_CONFIG } from '@/utils/constants'

export default {
  name: 'QuestionTopic',
  data () {
    return {
      question: {},
      urlQuestionImg: APP_CONFIG.urlQuestionImg,
      idOpenQuestion: null
    }
  },
  mounted () {
    this.getQuestionInfo()
  },
  methods: {
    getQuestionInfo () {
      const questionId = this.$route.params.id
      if (!questionId) {
        return
      }
      getQuestionDetail(parseInt(questionId)).then(res => {
        this.question = res ? res : {}
      })
    },

    handleToggleQuestionDesc (id) {
      this.idOpenQuestion = this.idOpenQuestion === id ? null : id
    }
  }
}
</script>

<style lang="scss">
  .question-topic {
    border-bottom: $border_main;

    &.question {
      padding: 15px 0;
    }

    &__head {

      &__title {
        margin-right: 8px;

        i {
          margin-right: 8px;
          transform: rotate(-90deg);
          -webkit-transform: rotate(-90deg);

          &.active {
            transform: rotate(0deg);
            -webkit-transform: rotate(0deg);
          }
        }
      }
    }

    &__img {
      padding: 10px 0;
    }

    p {
      margin: 0;
      line-height: 1.4;
    }
  }
</style>